// CUSTOM operators
import { filter } from 'rxjs/operators';
import { OperatorFunction } from 'rxjs';

/*export const filterEmpty = () => {
  return filter(item => isEmpty(item) as any);
};*/

export function filterEmptyValue<T>(): OperatorFunction<T | null | undefined, T> {
  return filter<T>(value => value !== undefined && value !== null);
}
